import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import tourSteps from "./steps";
import  {TourProvider } from '@reactour/tour';

// Create root using the new React 18 API
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Render with StrictMode for better development experience
root.render(
  <React.StrictMode>
     <TourProvider 
      steps={tourSteps} 
      prevButton={(btnProps) => 
        <btnProps.Button hideArrow={true} onClick={() => {
            btnProps.setCurrentStep(prev => Math.max(prev - 1, 0));
          }}>
          <button className='bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-md font-medium transition-colors duration-200'>Назад</button>
        </btnProps.Button> }
      nextButton={(btnProps) => 
        <btnProps.Button hideArrow={true} onClick={() => {
          const isLastStep = btnProps.currentStep === tourSteps.length - 1;
          if (isLastStep) {
                  if (globalThis.window !== undefined) {
                    localStorage.setItem('hasCompletedApplicationPageOnboarding', 'true');
                  }
                  btnProps.setIsOpen(false);
                }
          else { btnProps.setCurrentStep(prev => prev + 1); }
            }}>
          <button className='bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md font-medium transition-colors duration-200'>{ btnProps.currentStep === tourSteps.length - 1 ? "Завершить" : "Понятно"}</button>
        </btnProps.Button>} 
      onClickClose={(props) => {
          if (globalThis.window !== undefined) {
            localStorage.setItem('hasCompletedApplicationPageOnboarding', 'true');
          }
          props.setIsOpen(false);
          props.setCurrentStep(0); // Сбрасываем шаги после закрытия
        }}>
      <App />
     </TourProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
